<template>
  <div class="outer">
    <div class="login">
      <p><strong>ARCHETYPE</strong></p>
      <div class="control">
        <input type="text" placeholder="Email" v-model="email">
      </div>
      <div class="control">
        <input type="password" placeholder="Password" v-model="password">
      </div>
      <button v-on:click="signIn">Sign in</button>
    </div>
  </div>
</template>

<script>
  import firebase from 'firebase'

  export default {
    name: 'auth',
    data: function() {
      return {
        email: '',
        password: ''
      }
    },
    methods: {
      signIn: function() {
        firebase.auth().signInWithEmailAndPassword(this.email, this.password).then(
          (user) => {
            this.$router.replace('/')
          },
          (err) => {
            alert('Oops. ' + err.message)
          }
        );
      }
    }
  }
</script>

<style scoped>  /* "scoped" attribute limit the CSS to this component only */
  .outer {
    background: #eee;
    font-family: sans-serif;
    display: flex;
    align-items: center;
    height: 100vh;
  }
  .login {
    background: #eee;
    margin: auto;
    padding: 0 6rem 6rem;
    width: 20rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/Auth.vue